/** Public source-warning links for the German civil-protection feeds (NINA/DWD),
 *  which both publish to warnung.bund.de. The report/contributor itemId is shaped
 *  "{prefix}:{CAP-id}#{cell}" (e.g. "nina:mow.DE-MV-NB-W076-20260625-001#88…"); the
 *  CAP-id is the public message id that warnung.bund.de/meldungen resolves. */

const BUND_FEEDS = new Set(["nina", "dwd"]);

/** Build the warnung.bund.de detail URL for a NINA/DWD warning from its feed + itemId.
 *  Returns null for non-bund feeds or an itemId that yields no id (so callers can
 *  simply skip rendering the link). */
export function warnungBundUrl(feed: string | undefined, itemId: string | undefined): string | null {
  if (!feed || !BUND_FEEDS.has(feed) || !itemId) return null;
  const afterPrefix = itemId.includes(":") ? itemId.slice(itemId.indexOf(":") + 1) : itemId;
  const capId = afterPrefix.includes("#") ? afterPrefix.slice(0, afterPrefix.indexOf("#")) : afterPrefix;
  if (!capId) return null;
  return `https://warnung.bund.de/meldungen/${encodeURIComponent(capId)}`;
}
